import { memo, useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import { Checkbox } from 'primereact/checkbox';

import ChartDataLabels from 'chartjs-plugin-datalabels';

export const RevisaoGraficoArtigo = memo(function RevisaoGraficoArtigo({ data, month, dataProd, setor, type, title, defeitosengomagem3e4 = [] }) {
    const [chartData, setChartData] = useState({ });
    const [col, setCol] = useState("p-col-6");
    const [showEngomagem3e4, setShowEngomagem3e4] = useState(false);

    const chartOptions = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", {
                        maximumFractionDigits: type === "1" ? 0 : 2,
                    }).format(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50"
            },
        },
    }

    useEffect(() => {
        const allData = showEngomagem3e4 
        ? [...data, ...defeitosengomagem3e4] 
        : [...data];
        let filteredData = allData.filter((element) => { return parseInt(element.mes) === parseInt(month) && element.cod_defeitotipo === setor });
        let artigos = [];

        filteredData.forEach((item) => {
            if(artigos.findIndex((element) => { return element === item.cod_artigo }) === -1)
                artigos.push(item.cod_artigo);
        });

        let values = [];

        artigos.forEach((item) => {
            let filteredByArtigo = filteredData.filter((element) => { return element.cod_artigo === item });
            let total = filteredByArtigo.reduce((sum, currentValue) => sum + parseFloat(currentValue.soma), 0);
            if(type === "1") {
                values.push(total);
            } else {
                if(dataProd) {
                    let prodArtigo = dataProd.find((element) => { return parseInt(element.mes) === month && element.cod_artigo === item });
                    if(prodArtigo) {
                        let valorProdArtigo = parseFloat(prodArtigo.class1) + 
                            parseFloat(prodArtigo.class2) + 
                            parseFloat(prodArtigo.class3) + 
                            parseFloat(prodArtigo.class4);

                        if(valorProdArtigo > 0) {
                            values.push(parseFloat(total / valorProdArtigo * 100).toFixed(2));
                        } else {
                            values.push(0);
                        }
                    }
                }
            }
        });

        setChartData({
            labels: artigos,
            datasets: [
                { label: title, data: values, backgroundColor: "#2ecc71" }
            ]
        })
    }, [data, month, dataProd, setor, title, type, showEngomagem3e4, defeitosengomagem3e4]);

    return (
        <div className={col}>
            <Button 
                className="p-button-primary p-m-1"
                icon="pi pi-search"
                onClick={() => {
                    setCol(col => col === "p-col-6" ? "p-col-12" : "p-col-6")
                }}       
            />
            {setor === 3 && (
                <div className="p-d-flex p-ai-center p-mb-2">
                    <Checkbox 
                        inputId="engomagem"
                        checked={showEngomagem3e4}
                        onChange={(e) => setShowEngomagem3e4(e.checked)}
                    />
                    <label htmlFor="engomagem" className="p-ml-2">
                        Exibir defeitos Engomagem 3 e 4
                    </label>
                </div>
            )}
            <Chart 
                data={chartData}
                height="350px"
                options={chartOptions}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        </div>
    )
});